module.exports = __webpack_public_path__ + "binoculars.59f9d2ae139704c078c002623213b52e.svg";